var DialogLinkEquipmentModule = /** @class */ (function () {
    function DialogLinkEquipmentModule() {
    }
    return DialogLinkEquipmentModule;
}());
export { DialogLinkEquipmentModule };
